import React from "react";
import Modal from '@mui/material/Modal';
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "../../../../../../components/common/Button";
import Dropbox from "../../../../../../components/svgs/Dropbox";
import GoogleDrive from "../../../../../../components/svgs/GoogleDrive";
import SharePoint from "../../../../../../components/svgs/SharePoint";
import { toggleModal } from "../../../../../../reducers/modalReducer";
import { setUnallocatedFiles } from "../../../../../../reducers/filesReducer";
import DeduperReport from "../../../../../../components/modals/deduperReport";
import FileReportHistory from "../../../../../../components/modals/fileReportHistory";
import AuditLogModal from "../../../../../../components/modals/auditLog/auditLogModal";
import UnallocatedFilesModal from "../../../../../../components/modals/unallocateFiles";
import DisconnectDataroom from "../../../../../../components/modals/disconnectDataroom";
import ManageFilesModal from "../../../../../../components/modals/dataRepository/manageFilesModal";
import DeduperReportWaiting from "../../../../../../components/modals/deduperReport/deduperReportWaiting";
import WelcomToDashboardModal from "../../../../../../components/modals/dataRepository/welcomToDashboardModal";
import UserDefinedSectionModal from "../../../../../../components/modals/dataRepository/userDefinedSectionModal";
import DeleteFileConfirmModal from "../../../../../../components/modals/deleteFileConfirm/deleteFileConfirmModal";
import WarrantyDisclosureManageFilesModal from "../../../../../../components/modals/warrantyDisclosure/warrantyDisclosureManageFilesModal";
import ConnectDataroomModal from "../../../../../../components/modals/ConnectDataroomModal";
import DisclaimerModal from "../../../../../../components/modals/disclaimer";
import ModalWrapper from "../../../../../../components/common/Modal/ModalWrapper";

export default function ModalsSection({
    // Modal-related state
    deleteFile,
    deleteUnallocatedFile,
    deleteFileLoading,
    logModule,
    isSaving,
    attachment,
    additionalSections,
    isSectionNameDuplicate,
    isCustomSectionEnabled,
    newUpgradeSync,
    // Modal handlers
    confirmDeleteFile,
    confirmDeleteUnallocatedFile,
    moveUnallocatedFile,
    moveDeduperFile,
    onClickDeduperAuditLog,
    onClickUnallocatedBinAuditLog,
    onClickFileReportHistory,
    showDeduperReport,
    onClickDeduperReportHistory,
    onSaveAdditionalSections,
    editSectionName,
    onEdit,
    onDelete,
    handleToggleSuccessAiReportGeneratedModal,
    handleAiReportDisclaimerClose,
    getDeduperReportLogsHTML,
    getFileReportLogsHTML,
    getUnallocatedBinLogsHTML,
    getViewableURL,
    handleEditDispatch,
    handleFileChange,
    setDeleteFile,
    setDeleteFileQuestionId,
    setDeleteUnallocatedFile,
    setLoading,
    setRefresh,
    setSection,
    syncDrive,
    syncDropbox,
    syncSharePoint,
    openWindow,
    toggleReport,
    onMoveFile,
    // Redux state
    modal,
    user,
    logList,
    targetSection,
    processing,
    unallocatedFiles,
    dupCheck,
    // Parent props
    company,
    companyId,
    tab,
    activeModule,
    permissionLevel,
    advisors,
    profileClass,
    loading,
    section,
    reloadModule,
    reportHistories,
    setReportHistories,
    setFileReport,
    setCloneImportResult,
    setCurrentScore,
    fileImportRef,
    onRollbackComplete,
}) {
    const dispatch = useDispatch();

    return (
        <>
            {/* File Report History */}
            <FileReportHistory
                modalType={'fileReportHistory'}
                reportHistories={reportHistories}
                setReportHistories={setReportHistories}
                setFileReport={setFileReport}
                setCloneImportResult={setCloneImportResult}
                setCurrentScore={setCurrentScore}
                company={company}
                profileClass={profileClass}
                onRollbackComplete={onRollbackComplete}
                moduleType={tab}
                moduleId={activeModule?._id || null}
                moduleName={activeModule?.heading || tab}
            />

            {/* File Report History */}
            <DisconnectDataroom
                tab={tab}
                modalType={'disconnectDataRoom'}
                companyId={company?.['_id']}
            />

            {/* Unallocated Files */}
            <UnallocatedFilesModal
                modalType={'unallocatedFiles'}
                tab={tab}
                loading={loading}
                setLoading={setLoading}
                company={company}
                setUnallocatedFiles={setUnallocatedFiles}
                onClickUnallocatedBinAuditLog={onClickUnallocatedBinAuditLog}
                unallocatedFiles={unallocatedFiles}
                handleEditDispatch={handleEditDispatch}
                moveUnallocatedFile={moveUnallocatedFile}
                setDeleteUnallocatedFile={setDeleteUnallocatedFile}
                targetSection={targetSection}
            />

            {/* Manage Files */}
            <ManageFilesModal
                modalType={'manageFiles'}
                reloadModule={reloadModule}
                section={section}
                setSection={setSection}
                company={company}
                getViewableURL={getViewableURL}
                handleEditDispatch={handleEditDispatch}
                setDeleteFileQuestionId={setDeleteFileQuestionId}
                setDeleteFile={setDeleteFile}
                tab={tab}
                targetSection={targetSection}
                onMoveFile={onMoveFile}
            />

            <WarrantyDisclosureManageFilesModal
                modalType={'manageWarrantyDisclosureFiles'}
                reloadModule={reloadModule}
                section={section}
                setSection={setSection}
                company={company}
                getViewableURL={getViewableURL}
                handleEditDispatch={handleEditDispatch}
                setDeleteFileQuestionId={setDeleteFileQuestionId}
                setDeleteFile={setDeleteFile}
                tab={tab}
                targetSection={targetSection}
            />

            {/* Duplication Check Waiting  */}
            <DeduperReportWaiting
                modalType={'checkingDuplication'}
                company={company}
                onClickDeduperAuditLog={onClickDeduperAuditLog}
            />

            {/* File Deduplication Summary */}
            <DeduperReport
                modalType={'duplicationCheckSummary'}
                company={company}
                dupCheck={dupCheck}
                modal={modal}
                profileClass={profileClass}
                onClickDeduperAuditLog={onClickDeduperAuditLog}
                getViewableURL={getViewableURL}
                handleEditDispatch={handleEditDispatch}
                setRefresh={setRefresh}
                reloadModule={reloadModule}
                moveDeduperFile={moveDeduperFile}
                tab={tab}
            />

            {/* Allocating Files Waiting  */}
            <Modal open={modal['open'] == 'allocatingFiles'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
                <>
                    <div className="pr oya bg1 shadow w100 pl3rem pr3rem pb5rem pt0rem bsbb df fdc m1rem maw1000px br5px pr">
                        <div className="AnimateWiz tac">
                            <img className="h15rem mla mra" src={require(`../../../../../../../images/wizard.gif`)} alt="animWiz" />
                        </div>
                        <h2 className="fs1-5rem-sm w100 tac mb2rem c15">Performing Filing assistant magic!</h2>
                        <div className="tac">
                            <p className="c27 mb2rem">This may take a few seconds</p>
                            <p className="c27">We're now summoning the power of AI to allocating files to appropriate sections! <br></br>Please stay with us during this magical incantation.</p>
                        </div>
                    </div>
                    <div style={{ position: 'relative' }}>
                        <img src="https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/Group 1000002103-1733923364928.png" alt="messageLadie" className='girlImage1' />
                    </div>
                    <svg className="pa cp" onClick={() => dispatch(toggleModal({ open: '' }))} style={{ left: '50%', bottom: '80px', transform: 'translateX(-50%)' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
                        <path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
                    </svg>
                </>
            </Modal>

            {/* Connect Dataroom */}
            <ConnectDataroomModal company={company} />

            {/* User-defined sections modal */}
            <UserDefinedSectionModal
                onEdit={onEdit}
                onDelete={onDelete}
                modalType={'proaddsection'}
                editSectionName={editSectionName}
                additionalSections={additionalSections}
                isSectionNameDuplicate={isSectionNameDuplicate}
                onSaveAdditionalSections={onSaveAdditionalSections}
            />

            {/* Delete File */}
            <DeleteFileConfirmModal
                modalType="deleteFile"
                deleteFile={deleteFile}
                onConfirm={() => confirmDeleteFile(modal['from'])}
                onCancel={() => dispatch(toggleModal({ open: modal['from'] }))}
            />

            {/* Delete Unallocated File */}
            <DeleteFileConfirmModal
                modalType="deleteUnallocatedFile"
                deleteFile={deleteUnallocatedFile?.file ?? {}}
                onConfirm={confirmDeleteUnallocatedFile}
                onCancel={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))}
            />

            {/* Audit Log */}
            <AuditLogModal
                getViewableURL={getViewableURL}
                profileClass={profileClass}
                modalType={"auditLog"}
                logList={logList}
                logModule={logModule}
                tab={tab}
            />

            {/* Deduper Report Audit Log */}
            <Modal open={modal['open'] == 'deduperReportAuditLog'} onClose={() => dispatch(toggleModal({ open: 'duplicationCheckSummary' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
                <div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
                    <span className="pa t0 l0 m1rem ttc c7 fs1-5rem fw500">{company.subscription}</span>
                    <img className="h2rem pa t0 center-horizontally" src={require(`../../../../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
                    <button className="close-popup" onClick={() => dispatch(toggleModal({ open: 'duplicationCheckSummary' }))}>
                        <svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                        </svg>
                    </button>
                    <h1 className="text-gradient fs1-5rem fw600 tac">{company['cName']} Audit Log</h1>
                    <h2 className="c4 fs0-75rem ttc w100 tac mb1rem">See the history of Company Deduper Report</h2>
                    <div className="ma oya dg gg0-5rem mb2rem w100">
                        {logList.length > 0
                            ? getDeduperReportLogsHTML(logList)
                            : <h2 className="c4 fs1-50rem ttc w100 tac mb1rem">No Logs Found!!</h2>
                        }
                    </div>
                    <div className="df w100 fdr jcc ">
                        <button onClick={() => dispatch(toggleModal({ open: 'duplicationCheckSummary' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic">Go Back</button>
                    </div>
                </div>
            </Modal>

            {/* Unallocated Bin Audit Log */}
            <Modal open={modal['open'] == 'unallocatedBinAuditLog'} onClose={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
                <div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
                    <span className="pa t0 l0 m1rem ttc c7 fs1-5rem fw500">{company.subscription}</span>
                    <img className="h2rem pa t0 center-horizontally" src={require(`../../../../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
                    <button className="close-popup" onClick={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))}>
                        <svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                        </svg>
                    </button>
                    <h1 className="text-gradient fs1-5rem fw600 tac">{company['cName']} Audit Log</h1>
                    <h2 className="c4 fs0-75rem ttc w100 tac mb1rem">See the history of Company Unallocated Bin</h2>
                    <div className="ma oya dg gg0-5rem mb2rem w100">
                        {logList.length > 0
                            ? getUnallocatedBinLogsHTML(logList)
                            : <h2 className="c4 fs1-50rem ttc w100 tac mb1rem">No Logs Found!!</h2>
                        }
                    </div>
                    <div className="df w100 fdr jcc ">
                        {/* <button onClick={() => dispatch(toggleModal({ open: '' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic mr1rem">OK</button> */}
                        <button onClick={() => dispatch(toggleModal({ open: 'unallocatedFiles' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic">Go Back</button>
                    </div>
                </div>
            </Modal>

            {/* File Report Audit Log */}
            <Modal open={modal['open'] == 'fileReportAuditLog'} onClose={() => dispatch(toggleModal({ open: 'importSummary' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
                <div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
                    <span className="pa t0 l0 m1rem ttc c7 fs1-5rem fw500">{company.subscription}</span>
                    <img className="h2rem pa t0 center-horizontally" src={require(`../../../../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
                    <button className="close-popup" onClick={() => dispatch(toggleModal({ open: 'importSummary' }))}>
                        <svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                        </svg>
                    </button>
                    <h1 className="text-gradient fs1-5rem fw600 tac">{company['cName']} Audit Log</h1>
                    <h2 className="c4 fs0-75rem ttc w100 tac mb1rem">See the history of Company File Import</h2>
                    <div className="ma oya dg gg0-5rem mb2rem w100">
                        {logList.length > 0
                            ? getFileReportLogsHTML(logList)
                            : <h2 className="c4 fs1-50rem ttc w100 tac mb1rem">No Logs Found!!</h2>
                        }
                    </div>
                    <div className="df w100 fdr jcc ">
                        <button onClick={() => dispatch(toggleModal({ open: 'importSummary' }))} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp miw20 ttc bsbb tac mb1rem df jcc aic">Go Back</button>
                    </div>
                </div>
            </Modal>

            {/* Data Repository */}
            <WelcomToDashboardModal
                modalType={'dataRepository'}
                dispatch={dispatch}
                company={company}
                user={user}
            />

            {/* Repository Completed */}
            <Modal open={modal['open'] == 'repositoryCompleted'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
                <div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
                    <button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
                        <svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                        </svg>
                    </button>
                    <img className="h2rem pa t0 l0 m1rem" src={require(`../../../../../../../images/logo.svg`)} alt="TODO" />
                    <h1 className="text-gradient fw600 pb1rem">Congratulations!</h1>
                    <div className="tac df fdc jcc aic tac">
                        <p>Hello, {user.firstName}! 🎉</p>
                        <p>Look at you, unstoppable force! 🚀 You've made your first pass at filling your Data Repository and have emerged victorious! Now, it's time to step into your next adventure:</p>
                        <p>Unleash the magic of connectivity! Sync your Repository with your preferred provider Data Room. This will create an unbreakable bond between your treasures, keeping them safe and accessible anytime, anywhere. 🌐</p>
                        {company.gDriveLink && <button className="shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic" onClick={() => { dispatch(toggleModal({ open: '' })); syncDrive() }}>
                            <GoogleDrive className="pen fds w2rem mr1rem" />
                            👉 Sync Now
                        </button>}

                        <p>Excited to see the fruits of your labor? View your Repository Report and bask in the glory of your progress. Every detail counts in this journey, and you've made a remarkable headway! 📈</p>
                        <button onClick={e => { dispatch(toggleModal({ open: '' })); toggleReport(e); }} className="shadow my1rem mxa bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">👉 View Report</button>
                        <p>Feeling ready for the next level? It's time to take on the Quick Business Audit questionnaire! Upon its completion, Diligentsia's unaudited certification awaits. This prized possession will symbolize your company's readiness for any challenge ahead. 💼</p>
                        {(() => {
                            const [syncLink, driveName] = company.gDriveLink ? [company.gDriveLink, "Google Drive"]
                                : company.sharePointLink ? [company.sharePointLink, "SharePoint"]
                                    : company.dropBoxLink ? [company.dropBoxLink, "DropBox"]
                                        : [undefined, "Not Connected"];
                            return <>
                                {company.gDriveLink && <div className="df my1rem">
                                    <button className={`${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`} onClick={() => syncDrive()}>
                                        <GoogleDrive className="pen fds w2rem" />
                                        &nbsp;&nbsp;&nbsp;
                                        Sync Data room
                                    </button>
                                    {company['folderId'] &&
                                        <button className="ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100" onClick={() => openWindow(`https://drive.google.com/drive/folders/${company['folderId']}`)}>
                                            <GoogleDrive className="pen fds w2rem" />
                                            &nbsp;&nbsp;&nbsp;
                                            View Data Room
                                        </button>
                                    }
                                </div>}
                                {company.dropBoxLink && <div className="df my1rem">
                                    <button className={`${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`} onClick={() => syncDropbox()}>
                                        <Dropbox className="pen fds w2rem" />
                                        &nbsp;&nbsp;&nbsp;
                                        Sync Data room
                                    </button>
                                    {company['dropBoxFolderMetadata'] &&
                                        <button className="ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100" onClick={() => openWindow(`https://dropbox.com/home/${company['dropBoxFolderMetadata']['path_display']}`)}>
                                            <Dropbox className="pen fds w2rem" />
                                            &nbsp;&nbsp;&nbsp;
                                            View Data Room
                                        </button>
                                    }
                                </div>}
                                {company.sharePointLink && <div className="df my1rem">
                                    <button className={`${company['syncRequired'] ? 'bg4 bg3-hover ' : 'bg3 bg4-hover '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100`} onClick={() => syncSharePoint()}>
                                        <SharePoint className="pen fds w2rem" />
                                        &nbsp;&nbsp;&nbsp;
                                        Sync Data room
                                    </button>
                                    {company['sharePointLink'] &&
                                        <button className="ml1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic h100" onClick={() => openWindow(`${company['sharePointFolderDriveItem']['rootFolder']['webUrl']}`)}>
                                            <SharePoint className="pen fds w2rem" />
                                            &nbsp;&nbsp;&nbsp;
                                            View Data Room
                                        </button>
                                    }
                                </div>}
                                {syncLink == undefined && (
                                    tab == 'repository' && <button onClick={() => dispatch(toggleModal({ open: 'connectDataroom' }))} className={`${!company['uploadedFile'] && 'op20 pen '} my1rem shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`}>Connect Data Room</button>
                                )}
                            </>
                        })()}
                        <p>Remember, every adventure you undertake strengthens your fortress, builds your credibility, and takes your business one step closer to greatness. Keep conquering, {user['firstName']}! 👍</p>
                    </div>
                </div>
            </Modal>

            {/* Created DataRoom */}
            <Modal open={modal['open'] == 'createdDataRoom'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic" >
                <div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px pr pt5rem br5px pr">
                    <button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
                        <svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                        </svg>
                    </button>
                    <img className="h2rem pa t0 l0 m1rem" src={require(`../../../../../../../images/logo.svg`)} alt="TODO" />
                    <div className="tac my1rem">
                        <p className="mb0-5rem">Good news!  Your Cloud Data<br />Room has now been created.<br />You can now sync.​</p>
                    </div>
                    <div className="df jcc">
                        <button className="w60 shadow bg4 bg3-hover c1 td250 br5px px1rem py0-5rem mr1rem fw600 cp ttc bsbb df jcc" onClick={() => { window.location.href = `/company/${companyId}#repository` }}>Let's go!​</button>
                    </div>
                </div>
            </Modal>


            {/* New Applicant Investor Manual */}
            <Modal id="addingApplicantManual" open={modal['open'] == 'addingApplicantManual'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic" >
                <div className='df jcc oscy' style={{ maxHeight: '100vh' }}>
                    <div className='mah90 oya bg1 shadow w1100px p3rem bsbb df fdc aic m1rem br20px pr'>
                        <div class='w100 df fdc aic'>
                            <img className="my1rem" src={require(`../../../../../../../images/super-flow/complete-icon-popup.png`)} alt="" />
                            <p class='c15 fs1-25rem fw500 my1rem'>Thank you for adding this applicant</p>
                            <p class='c15 fs1rem fw300'>Your new applicant has been added and is ready for review.</p>
                            <p class='c15 fs1rem fw300'>Return to InvestorMatch to see the company and its newly generated reports.</p>
                        </div>
                        <div class='w100 df jcc my3rem'>
                            <Link to='/investor-dashboard#index?QualifiedLeads' onClick={() => localStorage.removeItem('isManualAdd')} className='df jcc cp px3rem py0-5rem c1 bg4 bg3-hover br35px fw400 fs1rem'>Return to InvestorMatch</Link>
                        </div>
                    </div>
                </div>
            </Modal>

            <DisclaimerModal
                modalType={'DisclaimerAIReportModal'}
                handleClose={handleAiReportDisclaimerClose}
                subTitle="This report is for guidance only."
                content="This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.  You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it."
            />


            <ModalWrapper
                modalType={'successAiReportGenerated'}
                customStyle={{ padding: '0px 0rem 2rem', maxWidth: '500px !important' }}
                onCloseHandler={() => handleToggleSuccessAiReportGeneratedModal(false)}
            >
                <div>
                    <div className='px4rem'>
                        <h3 className='c15 tal mt3rem'>AI report is ready.</h3>
                        <p className='c15 tal fs0-875rem my1rem' style={{ lineHeight: '1.5', color: '#505050' }}>
                            We've compiled your latest AI report. Review the insights now or come back whenever it suits you—your report will be waiting.
                        </p>
                        <div className='df jcc gg1rem fdcb-sm'>
                            <Button
                                style={{ width: '250px' }}
                                customClassName='mt1rem bg2'
                                text={'Go to Report'}
                                onClick={() => handleToggleSuccessAiReportGeneratedModal(true)}
                                btnType='warning'
                            />
                            <Button
                                style={{ width: '250px' }}
                                customClassName='mt1rem bg5 c15'
                                text={'Thanks, I will look later'}
                                onClick={() => handleToggleSuccessAiReportGeneratedModal(false)}
                                btnType='primary'
                            />
                        </div>
                    </div>
                </div>
            </ModalWrapper>
        </>
    );
}
